import { useMutation, UseMutationOptions } from "@tanstack/react-query";

import { useUnauthenticatedServer } from "../../server/ServerContext";
import { PortalAxiosError } from "../../types";
import { SignupVariables, ThirdPartyAuthentication } from "./types";

export const useSignup = (
  options?: UseMutationOptions<
    ThirdPartyAuthentication,
    PortalAxiosError,
    SignupVariables
  >
) => {
  const unauthenticatedServer = useUnauthenticatedServer();

  return useMutation<
    ThirdPartyAuthentication,
    PortalAxiosError,
    SignupVariables
  >(
    (variables) =>
      unauthenticatedServer.post("auth", {
        user: variables,
      }),
    options
  );
};

export default useSignup;
